import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress } from "@material-ui/core";
import { PollPanelStyle } from '../../infrastructure/PollPanelStyle';

export const EditPoll = ({ dataEdit, editPoll }) => {
    const classes = PollPanelStyle();
    const [isLoanding, setisLoanding] = useState(false)

    return (
        <Formik

            initialValues={{
                nombre: dataEdit.name,
                descripcion: dataEdit.description,

            }}

            validate={(valores) => {

                let errores = {};

                if (!valores.nombre) {
                    errores.nombre = 'Por favor ingresa un nombre'
                } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(valores.nombre)) {
                    errores.nombre = 'No se aceptan caracteres especiales ni números'
                }

                if (!valores.descripcion) {
                    errores.descripcion = 'Por favor ingresa una descripcion'
                } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(valores.descripcion)) {
                    errores.descripcion = 'No se aceptan caracteres especiales ni números'
                }


                return errores;

            }}

            onSubmit={(valores, { resetForm }) => {

                setisLoanding(true)

                const data = {
                    id: dataEdit.id,
                    name: valores.nombre,
                    description: valores.descripcion,
                    canal: dataEdit.canal,
                    num_question: dataEdit.num_question,
                    status: dataEdit.status
                }
                editPoll(data)
                valores.isLoading = true;
                setTimeout(() => {
                    setisLoanding(false)
                }, 2000);

                resetForm();
            }}
        >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Nombre</InputLabel>
                                <OutlinedInput
                                    id="nombre"
                                    type="total"
                                    name='nombre'
                                    defaultValue={values.nombre}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                    style={{ borderRadius: '10px' }}

                                />
                            </FormControl>
                            {touched.nombre && errors.nombre && <div style={{ color: "red" }}>{errors.nombre}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="nombre">Descripcion</InputLabel>
                                <OutlinedInput
                                    id="descripcion"
                                    type="total"
                                    name='descripcion'
                                    defaultValue={values.descripcion}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                    style={{ borderRadius: '10px' }}

                                />
                            </FormControl>
                            {touched.descripcion && errors.descripcion && <div style={{ color: "red" }}>{errors.descripcion}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>

                        </Grid>
                    </Grid>
                    <div className={classes.wrapper}>
                        <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                            <Button
                                disabled={isLoanding}
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: "50%", borderRadius: '10px' }}
                            >
                                Editar encuesta
                            </Button>
                        </Grid>
                        {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </form>
            )}
        </Formik>
    );
}